/* eslint-disable array-callback-return */
/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useCallback, useEffect, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import SalesIcon from "../../../../../assets/images/icon_menus/SalesIcon.json";
import clsx from 'clsx';
import { Row, Col, Image, Space } from "antd";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { InputAdornment, TextField, Button } from "@mui/material";
import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import { CustomerSettlementTable } from "./CustomerSettlementTable";
import managementActions from "../../../Management/redux/actions";
import actions from "../../redux/actions";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import usePrevious from "../../../../Shared/components/Previous";
import { BlinkedBox } from "../../../../../helpers/utilities";
import crudActions from "../../../../CRUD/redux/actions";
import { toast } from 'react-toastify';
import { AESEncrypt, AESDecrypt } from "../../../../../helpers/Crypto";

const CustomerSettlement = (props) => {
    const { history } = props;
    const tableRef = useRef('');
    const { openInvoiceList, openInvoiceData, openInvoiceLoader,
        openPaymentList, openPaymentData, openPaymentLoader, closeInvoiceDetails,
        closeInvoiceLoader, closePaymentDetails, closePaymentLoader } = useSelector(state => state.salesSettlementReducer);
    const { customerDetails } = useSelector(state => state.salesManagementReducer);
    const { createDetails, createError, createLoader } = useSelector(state => state.crudReducer);
    const dispatch = useDispatch();
    const [reversed, setReversed] = useState(true);
    let { customerSettlementID } = useParams();
    const [oISkip, setOISkip] = useState(0);
    const [oPSkip, setOPSkip] = useState(0);

    const [sortOIOrder, setSortOIOrder] = useState("asc");
    const [sortOIBy, setSortOIBy] = useState("id");

    const [sortOPOrder, setSortOPOrder] = useState("asc");
    const [sortOPBy, setSortOPBy] = useState("id");

    const [sortCIOrder, setSortCIOrder] = useState("asc");
    const [sortCIBy, setSortCIBy] = useState("id");

    const limit = 25;
    const [oILoadMore, setOiLoadMore] = useState(false);
    const [oILoadMoreContent, setOiLoadMoreContent] = useState(false);

    const [oPLoadMore, setOpLoadMore] = useState(false);
    const [oPLoadMoreContent, setOpLoadMoreContent] = useState(false);

    const [search, setSearch] = useState('');
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const customerId = AESDecrypt(customerSettlementID);
    const [warningMsg, handleWarningMsg] = useState(false);
    const [iconAnimation, setIconAnimation] = useState(false);

    const [OIMarkedAmount, setOIMarkedAmount] = useState(0);
    const [OPMarkedAmount, setOPMarkedAmount] = useState(0);
    const [CIMarkedAmount, setCIMarkedAmount] = useState(0);
    const [CPMarkedAmount, setCPMarkedAmount] = useState(0);

    const [OIselected, setOISelected] = useState([]);
    const [OPselected, setOPSelected] = useState([]);
    const [CIselected, setCISelected] = useState([]);
    const [CPselected, setCPSelected] = useState([]);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);

    const onSelected = (data) => {

    };

    const handleReversed = () => {
        setReversed(false);
        let cArray = [];
        CIselected && CIselected.map((data, ci) => {
            let e = data.split("_");
            cArray.push({
                paymentId: parseInt(e[1]),
                invoiceId: parseInt(e[0])
            });
        });

        dispatch({
            type: crudActions.CREATE_DETAILS_START,
            url: `/customerSettlement/reverse`,
            title: 'Customer Settlement',
            details: cArray
        });
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFillter(customerId, search);
            } else {
                timeoutRef.current = setTimeout(() => {
                    dispatchFillter(customerId, search);
                }, 500);
            }
        }
    }, [search]);


    useEffect(() => {
        if (customerSettlementID === undefined || customerId === 0) {
            history.push("/sales/sales-management/all-customers");
            return true;
        }
        dispatch({ type: managementActions.CUSTOMER_DETAILS_START, url: 'customerProfile' });
        dispatchFillter(customerId, search);
    }, []);

    const loadMoreOpenInvoiceTask = () => {
        let s = oISkip + limit;
        openInvoice(customerId, search, sortOIBy, sortOIOrder, s);
    }

    const loadMoreOpenPaymentTask = () => {
        let s = oPSkip + limit;
        openPayments(customerId, search, sortOPBy, sortOPOrder, s);
    }

    const openInvoice = (customerId, search, sortBy = 'id', sortOrder = 'desc', skip = 0) => {
        if (skip === 0) {
            setOiLoadMore(false);
            setOiLoadMoreContent(false);
        }
        var oIfilter = { ["and"]: [] };
        let or = { ["or"]: [] };
        if (customerId !== '') {
            oIfilter['and'].push({ customerId: customerId });
        }
        oIfilter['and'].push({ "or": [{ type: 'SALES SELF-BILL' }, { type: 'STORE SALES INVOICE' }, { type: 'PAYMENT REVERSAL' }] });
        oIfilter['and'].push({ closed: false });
        if (search !== '') {
            or['or'].push({ taxInvoice: { like: '%' + search.trim() + '%' } });
            or['or'].push({ amount: { like: '%' + search.trim() + '%' } });
            or['or'].push({ balance: { like: '%' + search.trim() + '%' } });
            or['or'].push({ paymentReference: { like: '%' + search.trim() + '%' } });
        }

        oIfilter['and'].push(or);
        setOISkip(skip);
        dispatch({
            type: actions.OPEN_INVOICE_DETAILS_START, url: `customerTransaction/${customerId}/invoices`,
            skip: skip,
            filter: { where: oIfilter, order: sortBy + ' ' + sortOrder, skip: skip, limit: limit }
        });
    }

    const openPayments = (customerId, search, sortBy = 'id', sortOrder = 'desc', skip = 0) => {
        if (skip === 0) {
            setOpLoadMore(false);
            setOpLoadMoreContent(false);
        }
        let oPfilter = { ["and"]: [] };
        let or = { ["or"]: [] };
        if (customerId !== '') {
            oPfilter['and'].push({ customerId: customerId });
        }
        oPfilter['and'].push({ "or": [{ type: 'PAYMENT' }, { type: 'INVOICE CANCEL' }, { type: 'SELF BILL-CREDIT NOTE' }] });
        oPfilter['and'].push({ closed: false });
        if (search !== '') {
            or['or'].push({ taxInvoice: { like: '%' + search.trim() + '%' } });
            or['or'].push({ amount: { like: '%' + search.trim() + '%' } });
            or['or'].push({ balance: { like: '%' + search.trim() + '%' } });
            or['or'].push({ paymentReference: { like: '%' + search.trim() + '%' } });
        }
        oPfilter['and'].push(or);
        setOPSkip(skip);
        dispatch({
            type: actions.OPEN_PAYMENT_DETAILS_START, url: `customerTransaction/${customerId}/payments`, skip: skip,
            filter: { where: oPfilter, order: sortBy + ' ' + sortOrder, skip: skip, limit: limit }
        });
    }

    const closeInvoicePayments = (customerId, search, sortBy = 'id', sortOrder = 'desc', skip = 0) => {
        let cIfilter = { ["and"]: [] };
        let or = { ["or"]: [] };
        if (customerId !== '') {
            cIfilter['and'].push({ customerId: customerId });
        }
        if (search !== '') {
            or['or'].push({ taxInvoice: { like: '%' + search.trim() + '%' } });
            or['or'].push({ amount: { like: '%' + search.trim() + '%' } });
            or['or'].push({ balance: { like: '%' + search.trim() + '%' } });
            or['or'].push({ paymentReference: { like: '%' + search.trim() + '%' } });
        }

        cIfilter['and'].push(or);
        dispatch({
            type: actions.CLOSE_INVOICE_DETAILS_START, url: `customerSettlement/${customerId}/closedTransaction`,
            filter: { where: cIfilter }
        });
    }

    const dispatchFillter = (customerId, search) => {
        openInvoice(customerId, search);
        openPayments(customerId, search);
        closeInvoicePayments(customerId, search);
    }

    const customerObject = () => {
        let a = customerDetails && customerDetails.filter((el) => { return el.id === parseInt(customerId) });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const requestOISort = (sortBy, sortOrder) => {
        setSortOIBy(sortBy);
        setSortOIOrder(sortOrder);
        openInvoice(customerId, search, sortBy, sortOrder);
    }

    const requestOPSort = (sortBy, sortOrder) => {
        setSortOPBy(sortBy);
        setSortOPOrder(sortOrder);
        openPayments(customerId, search, sortBy, sortOrder);
    }

    const requestCISort = (sortBy, sortOrder) => {
        setSortCIBy(sortBy);
        setSortCIOrder(sortOrder);
        closeInvoicePayments(customerId, search, sortBy, sortOrder);
    }

    const settleAmountFunction = (OIMarkedAmount, OPMarkedAmount, CIMarkedAmount, CPMarkedAmount) => {
        setOIMarkedAmount(OIMarkedAmount);
        setOPMarkedAmount(OPMarkedAmount);
        setCIMarkedAmount(CIMarkedAmount);
        setCPMarkedAmount(CPMarkedAmount);
    }

    const settleFunction = (OIselected, OPselected) => {
        setOISelected(OIselected);
        setOPSelected(OPselected);
    }

    const reverseFunction = (CIselected) => {
        setCISelected(CIselected);
    }

    const handleSettle = () => {
        let selectedPayments = openPaymentList.filter(function (el) { return OPselected.find(e => e === el.id) });
        let selectedInvoices = openInvoiceList.filter(function (el) { return OIselected.find(e => e === el.id) });
        let settle = [], invoices = [];
        selectedInvoices && selectedInvoices.map((iData, si) => {
            let mLines = [];
            for (const [key, value] of Object.entries(iData)) {
                mLines[key] = value
            }
            let amount = iData.calcAmount;
            let costAmount = iData.costAmount;
            let iBalance = iData.balance;
            if (amount > 0) {
                selectedPayments && selectedPayments.map((pData, i) => {
                    let balance = pData.balance;
                    let pLines = [];
                    for (const [key, value] of Object.entries(pData)) {
                        pLines[key] = value
                    }
                    if (amount > 0 && balance > 0) {
                        if (amount >= balance) {
                            amount = amount - balance;
                            pLines['balance'] = 0;
                            balance = 0;
                            mLines['amount'] = amount;
                            selectedPayments.splice(i, 1, pLines);
                            selectedInvoices.splice(si, 1, mLines);
                            settle.push({
                                'amount': pData.balance,
                                'paymentId': pData.id,
                                'invoiceId': iData.id,
                                'fullySettled': (iBalance - costAmount === 0) ? true : false
                            });
                        } else if (amount < balance) {
                            settle.push({
                                'amount': amount,
                                'paymentId': pData.id,
                                'invoiceId': iData.id,
                                'fullySettled': (iBalance - costAmount === 0) ? true : false
                            });
                            amount = balance - amount;
                            pLines['balance'] = amount;
                            balance = amount;
                            mLines['amount'] = 0;
                            amount = 0;
                            selectedPayments.splice(i, 1, pLines);
                            selectedInvoices.splice(si, 1, mLines);
                        }
                    }
                });
            }
        });

        dispatch({
            type: crudActions.CREATE_DETAILS_START,
            url: `/customerPayment/settle`,
            title: 'Customer Settlement',
            details: settle
        });
    }


    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            toast.dismiss();
            toast(reversed ? createDetails : 'Customer Settlement reversed successfully');
            dispatchFillter(customerId, search);
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message;
            toast.dismiss();
            toast.error(error);
        }
    }, [createDetails, createError]);

    const prevOpenInvoiceGetData = usePrevious(openInvoiceData);
    useEffect(() => {
        if (oILoadMore && openInvoiceData === '') {
            setOiLoadMoreContent(false);
            setOiLoadMore(true);
        }
        if (prevOpenInvoiceGetData !== undefined && openInvoiceData && prevOpenInvoiceGetData !== openInvoiceData) {
            const timer = setTimeout(() => {
                if (openInvoiceData && Array.isArray(openInvoiceData) && openInvoiceData.length > 0) {
                    setOiLoadMore(true);
                    if (openInvoiceData.length < limit) {
                        setOiLoadMoreContent(false);
                    } else {
                        setOiLoadMoreContent(true);
                    }
                } else {
                    setOiLoadMoreContent(false);
                    setOiLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [openInvoiceData]);


    const prevOpenPaymentGetData = usePrevious(openPaymentData);
    useEffect(() => {
        if (oPLoadMore && openPaymentData === '') {
            setOpLoadMoreContent(false);
            setOpLoadMore(true);
        }
        if (prevOpenPaymentGetData !== undefined && openPaymentData && prevOpenPaymentGetData !== openPaymentData) {
            const timer = setTimeout(() => {
                if (openPaymentData && Array.isArray(openPaymentData) && openPaymentData.length > 0) {
                    setOpLoadMore(true);
                    if (openPaymentData.length < limit) {
                        setOpLoadMoreContent(false);
                    } else {
                        setOpLoadMoreContent(true);
                    }
                } else {
                    setOpLoadMoreContent(false);
                    setOpLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [openPaymentData]);


    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader  {...props} cls={'newImg'} img={SalesIcon} title={'Sales'} links={[{ 'label': 'Sales', 'link': '/sales' }, { 'label': 'All Customers', 'link': '/sales/sales-management/all-customers' }, { 'label': 'Customer Detail', 'link': customerId ? `/sales/sales-management/all-customers/${AESEncrypt(customerId)}/View` : '/sales/sales-management/all-customers' }, { 'label': 'Customer Settlement', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.settlementTable)}>
                <PrimaryCard
                    title={'Customer Settlement'}
                    customClass={classes.customerSettlement}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={7} xl={7} lg={7} md={12} sm={12} xs={24}>
                                    <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                        <TextField autoComplete='one-time-code'
                                            placeholder='Search'
                                            type='search'
                                            fullWidth
                                            onChange={(e) => setSearch(e.target.value)}
                                            className={classes.comInput}
                                            variant={'standard'}
                                            onFocus={() => setIconAnimation(true)}
                                            onBlur={() => setIconAnimation(false)}
                                        />
                                        <Image
                                            src={SearchIcon}
                                            preview={false}
                                        />
                                    </div>
                                </Col>
                                <Col xxl={10} xl={10} lg={10} md={0} sm={0} xs={0} className={clsx(classes.textAlignCenter, classes.blinktext)}>
                                    {
                                        !warningMsg && OIMarkedAmount !== 0 && OPMarkedAmount !== 0 && OIMarkedAmount > OPMarkedAmount &&
                                        <BlinkedBox onChange={() => handleWarningMsg()} className={clsx(classes.typographyHeader, classes.rejectRed, classes.bold, classes.textalignLeft, classes.headerGT)}>
                                            Open Invoices Should be Lesser than Open Credits & Payments
                                        </BlinkedBox>
                                    }
                                </Col>
                                <Col xxl={7} xl={7} lg={7} md={12} sm={12} xs={24} className={clsx(classes.textAlignRight,
                                    classes.removeUnderline, classes.customerLabelNone, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space direction="horizontal" align="center" size={[20, 20]}>
                                            {
                                                reversed ?
                                                    <React.Fragment>
                                                        <Button
                                                            key="un mark"
                                                            color="primary"
                                                            variant="contained"
                                                            onClick={() => tableRef.current.onEmpty()}
                                                            className={clsx(classes.AddMoreBtn)}
                                                        >Un-mark</Button>
                                                        <Button
                                                            key="settle"
                                                            color="primary"
                                                            variant="contained"
                                                            onClick={(e) => handleSettle(e)}
                                                            className={clsx(clsx(classes.modalBtn, { [classes.disabled]: (OIMarkedAmount === 0 || OPMarkedAmount === 0 || OIMarkedAmount > OPMarkedAmount) }, { [classes.loading]: createLoader }))}
                                                        >Settle</Button>
                                                    </React.Fragment> : <Button
                                                        key="reversed"
                                                        color="primary"
                                                        onClick={() => handleReversed()}
                                                        variant="contained"
                                                        className={clsx(classes.deleteBtn, classes.marginRight0, { [classes.disabled]: CIMarkedAmount === 0 }, { [classes.loading]: createLoader })}
                                                    >Reverse</Button>
                                            }
                                            {/* <Image
                                                src={FilterIcon}
                                                preview={false}
                                            /> */}
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <CustomerSettlementTable
                                ref={tableRef}
                                loadMoreOpenInvoiceTask={() => loadMoreOpenInvoiceTask()}
                                loadMoreOpenPaymentTask={() => loadMoreOpenPaymentTask()}
                                onSelected={onSelected}
                                customerDetails={customerObject()}
                                openInvoiceDetails={openInvoiceList}
                                openInvoiceLoader={openInvoiceLoader}
                                openPaymentDetails={openPaymentList}
                                openPaymentLoader={openPaymentLoader}
                                closeInvoiceDetails={closeInvoiceDetails}
                                closeInvoiceLoader={closeInvoiceLoader}
                                closePaymentDetails={closePaymentDetails}
                                closePaymentLoader={closePaymentLoader}
                                sortOIOrder={sortOIOrder}
                                sortOIBy={sortOIBy}
                                sortOPOrder={sortOPOrder}
                                sortOPBy={sortOPBy}
                                sortCIOrder={sortCIOrder}
                                sortCIBy={sortCIBy}
                                handleWarningMsg={handleWarningMsg}
                                setReversed={setReversed}
                                dispatchFillter={(customerId, search) => dispatchFillter(customerId, search)}
                                settleAmountFunction={(OIMarkedAmount, OPMarkedAmount, CIMarkedAmount, CPMarkedAmount) => settleAmountFunction(OIMarkedAmount, OPMarkedAmount, CIMarkedAmount, CPMarkedAmount)}
                                settleFunction={(OIselected, OPSelected) => settleFunction(OIselected, OPSelected)}
                                reverseFunction={(CISelected) => reverseFunction(CISelected)}
                                requestOISort={(sortBy, sortOrder, table) => requestOISort(sortBy, sortOrder, table)}
                                requestOPSort={(sortBy, sortOrder, table) => requestOPSort(sortBy, sortOrder, table)}
                                requestCISort={(sortBy, sortOrder, table) => requestCISort(sortBy, sortOrder, table)}
                                customerId={customerId}
                                search={search}
                                oILoadMore={oILoadMore}
                                oILoadMoreContent={oILoadMoreContent}
                                oPLoadMore={oPLoadMore}
                                oPLoadMoreContent={oPLoadMoreContent}
                            />
                        </>
                    }
                />
            </div>
        </React.Fragment>
    )
}

export default CustomerSettlement